// Shared email gate for the gated report download forms.
//
// Two rules, deliberately enforced at different points:
//   - PERSONAL_EMAIL_DOMAINS   blocks the submit outright.
//   - RESTRICTED_EMAIL_DOMAINS lets the submit through so the lead is still
//     recorded, then withholds the report afterwards - see isRestrictedEmail().

// Data/research providers whose submissions are stored but never served a report.
export const RESTRICTED_EMAIL_DOMAINS = [
  'privatecircle.co',        // PrivateCircle
  'vccedge.com',             // VCCEdge
  'vccircle.com',            // VCCircle
  'tracxn.com',              // Tracxn
  'probe42.in',              // Probe
  'zaubatechnologies.com',   // Zauba
  'zaubacorp.com',           // Zauba Corp
  'instafinancials.com',     // Instafinancials
  'tofler.in',               // Tofler
  'karza.in',                // Karza
  'crediwatch.com',          // Crediwatch
  'yourstory.com',           // YourStory Research
  'corpository.com',         // Corpository
  'pitchbook.com',           // PitchBook
  'crunchbase.com',          // Crunchbase
  'cbinsights.com',          // CB Insights
];

// Free/personal mailbox providers - only professional (work) email ids are accepted.
export const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.co.in', 'yahoo.in', 'ymail.com',
  'rocketmail.com', 'hotmail.com', 'hotmail.co.uk', 'outlook.com', 'outlook.in',
  'live.com', 'msn.com', 'aol.com', 'icloud.com', 'me.com', 'mac.com',
  'rediffmail.com', 'rediff.com', 'protonmail.com', 'proton.me', 'zoho.com',
  'zohomail.com', 'gmx.com', 'gmx.de', 'mail.com', 'yandex.com', 'yandex.ru',
  'inbox.com', 'fastmail.com', 'hushmail.com', 'tutanota.com', 'mail.ru',
  'qq.com', '163.com', '126.com', 'sina.com',
];

const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

export const getEmailDomain = (email) =>
  String(email || '').trim().toLowerCase().split('@')[1] || '';

// Matches the domain itself and any subdomain of it, so a list entry such as
// 'tracxn.com' also covers 'mail.tracxn.com'. Regional variants that are not a
// subdomain (tracxn.co.in) still need their own entry in the list.
const matchesDomain = (domain, list) =>
  !!domain && list.some((d) => domain === d || domain.endsWith(`.${d}`));

// Shown after a restricted submission has been received and stored.
export const RESTRICTED_ACCESS_MESSAGE =
  'This email address isn’t eligible to access this report.';

// Restricted domains intentionally pass validateEmail() so the form still
// submits and the lead is captured; the report is withheld after the response.
export const isRestrictedEmail = (email) =>
  matchesDomain(getEmailDomain(email), RESTRICTED_EMAIL_DOMAINS);

// Blocks the submit. Returns an error message, or '' when the form may be sent.
export const validateEmail = (email) => {
  const value = String(email || '').trim();
  if (!value) return 'Please enter your email id.';
  if (!EMAIL_PATTERN.test(value)) return 'Please enter a valid email id.';

  if (matchesDomain(getEmailDomain(value), PERSONAL_EMAIL_DOMAINS)) {
    return 'Please use your professional (work) email id. Personal email ids are not accepted.';
  }
  return '';
};
